import { FC } from 'react'
import NextHead from 'next/head'

const Head: FC = () => {
    return (
        <NextHead>
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1"
            />
            <meta
                name="p:domain_verify"
                content="ZbB9iDGv7aukR6Zi7XAqWO2cSxBhPbtU"
            />
            <link
                rel="manifest"
                href="/site.webmanifest"
                crossOrigin="use-credentials"
                key="site-manifest"
            />
            <link rel="stylesheet" href="https://use.typekit.net/pdj6lvi.css" />
        </NextHead>
    )
}

export default Head
